import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-blog',
  templateUrl: './blog.component.html',
  styleUrls: ['./blog.component.css']
})
export class BlogComponent implements OnInit {

 // trustedHtml: SafeHtml;
 // msg: string = "";
  constructor() { }

  //constructor(public s: DomSanitizer) { }

  ngOnInit() {
   // this.addDiv();
  }

 /* public addDiv() {
    this.msg="<div class='blog-box row'>"
      this.msg+="<div class='col-md-4'>"
        this.msg+="<div class='post-media'>"
          this.msg+="<a [routerLink]='['/quantum-computing']' class='readmore'>"
            this.msg+="<img src='../assets/img/blog/Quantum.jpg' class='img-fluid'>"
              this.msg+="<div class='hovereffect'></div>"
          this.msg+="</a>"
        this.msg+="</div>"    
      this.msg+="</div>"

      this.msg+="<div class=\"blog-meta big-meta col-md-8\">"
        this.msg+="<h4><a [routerLink]=\"['/quantum-computing']\" class=\"readmore\">Quantum Computing</a></h4>"
        this.msg+="<p style=\"text-align: justify;\">Quantum computing is an emerging field that has significant potential, especially in the area of optimization problems. </p>"
        this.msg+="<small><a [routerLink]=\"['/quantum-computing']\" class=\"readmore\">11 September, 2021</a></small>"
      this.msg+="</div>"
    this.msg+="</div>"
  
    //this.trustedHtml = this.s.bypassSecurityTrustHtml("<div class='blog-box row'></div>")
    this.trustedHtml = this.s.bypassSecurityTrustHtml(this.msg)
}*/

}
